<template>
  <form data-vv-scope="custom-document" autocomplete="off" @submit.prevent>
    <h2 class="mb-10">Formulario de Solicitud Compra de Pasajes</h2>
    <div class="row">
      <div class="col-md-12">
        <p class="text-justify">
          Para la compra de pasajes nacionales e internacionales se requiere completar
          todos los datos solicitados y adjuntar Itinerario de desplazamiento, el programa
          de actividades a realizar durante la comisión de servicio.
          La solicitud debe ser tramitada con un plazo mínimo de antelación de 20 días
          corridos previos a la fecha de inicio(30 días en caso de INTERNACIONAL).
          En caso de no cumplir con este plazo, el formulario de solicitud deberá contar
          con la respectiva justificación y la visación del Jefe de Servicio.
        </p>
      </div>
    </div>
    <div class="row mt-2">
      <div class="col-md-12 mt-5 mb-2">
        <h6>Datos pasajero</h6>
      </div>
      <div class="col-md-6">
        <b-form-group label="Nombre *">
          <b-form-input
            :state="errors.has('custom-document.name') ? false : null"
            data-vv-as="nombre"
            data-cy="name"
            name="name"
            v-model="formData.name"
            v-validate="'required'"
            maxLength="150"
          />
          <div
            v-if="errors.has('custom-document.name')"
            class="con-text-validation span-text-validation-danger v-enter-to"
          >
            <span class="span-text-validation">
              {{ errors.first('custom-document.name') }}
            </span>
          </div>
        </b-form-group>
      </div>
      <div class="col-md-6">
        <b-form-group label="Apellidos *">
          <b-form-input
            :state="errors.has('custom-document.surnames') ? false : null"
            data-vv-as="apellidos"
            data-cy="surnames"
            name="surnames"
            v-model="formData.surnames"
            v-validate="'required'"
            maxLength="150"
          />
          <div
            v-if="errors.has('custom-document.surnames')"
            class="con-text-validation span-text-validation-danger v-enter-to"
          >
            <span class="span-text-validation">
              {{ errors.first('custom-document.surnames') }}
            </span>
          </div>
        </b-form-group>
      </div>
      <div class="col-md-4">
        <b-form-group label="Cédula de identidad *">
          <b-form-input
            :state="errors.has('custom-document.iut') ? false : null"
            data-vv-as="rut"
            data-cy="iut"
            name="iut"
            v-model="formData.iut"
            placeholder="12345678-9"
            @blur="formatIut(formData.iut, undefined, 'si')"
            v-validate="'required|validateRut'"
          />
          <div
            v-if="errors.has('custom-document.iut')"
            class="con-text-validation span-text-validation-danger v-enter-to"
          >
            <span class="span-text-validation">
              {{ errors.first('custom-document.iut') }}
            </span>
          </div>
        </b-form-group>
      </div>
      <div class="col-md-4">
        <b-form-group label="Fecha de nacimiento *">
          <date-picker
            data-cy="birthdate"
            class="w-100"
            name="birthdate"
            format="DD-MM-YYYY"
            value-type="YYYY-MM-DD"
            data-vv-as="fecha de nacimiento"
            :danger="errors.has('custom-document.birthdate')"
            :danger-text="errors.first('custom-document.birthdate')"
            v-validate="'required'"
            v-model="formData.birthdate"
          />
          <div v-if="errors.has('custom-document.birthdate')">
            <small class="text-danger">
              {{ errors.first('custom-document.birthdate') }}
            </small>
          </div>
        </b-form-group>
      </div>
      <div class="col-md-4">
        <b-form-group label="Teléfono *">
          <b-form-input
            :state="errors.has('custom-document.phone') ? false : null"
            data-vv-as="teléfono"
            data-cy="phone"
            name="phone"
            placeholder="+569 1234-5678"
            v-mask="'+569 ####-####'"
            v-model="formData.phone"
            v-validate="{
              required: true
            }"
          />
          <div
            v-if="errors.has('custom-document.phone')"
            class="con-text-validation span-text-validation-danger v-enter-to"
          >
            <span class="span-text-validation">
              {{ errors.first('custom-document.phone') }}
            </span>
          </div>
        </b-form-group>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12 mt-5 mb-2">
        <h6>Itinerario</h6>
        <p>
          La fechas y horas  deben ser estimativos, ya que está dependerá de la
          disponibilidad. Se les recuerda que siempre se escogerá el vuelo más
          económico dentro del día pudiendo este ser de madrugada.
          EL ORIGEN SIEMPRE SERA SANTIAGO Y LOS VUELOS SON TODOS CON IDA Y VUELTA.
        </p>
      </div>
      <div class="col-md-12">
        <div class="row">
          <label for="tripType" class="col-sm-2 col-form-label">Tipo de viaje *</label>
          <div class="col-sm-10">
            <vs-radio
              type="radio"
              id="oneWay"
              vs-name="tripType"
              :vs-value="'oneWay'"
              v-model="formData.tripType"
            />
            <label for="oneWay">Solo ida</label><br>
            <vs-radio
              type="radio"
              id="roundTrip"
              vs-name="tripType"
              :vs-value="'roundTrip'"
              v-model="formData.tripType"
            />
            <label for="roundTrip">Ida y vuelta</label>
          </div>
        </div>
      </div>
      <div class="col-md-6">
        <b-form-group label="Origen *">
          <b-form-input
            :state="errors.has('custom-document.from') ? false : null"
            data-vv-as="origen"
            data-cy="from"
            name="from"
            v-model="formData.from"
            v-validate="'required'"
            maxLength="150"
          />
          <div
            v-if="errors.has('custom-document.from')"
            class="con-text-validation span-text-validation-danger v-enter-to"
          >
            <span class="span-text-validation">
              {{ errors.first('custom-document.from') }}
            </span>
          </div>
        </b-form-group>
      </div>
      <div class="col-md-6">
        <b-form-group label="Destino *">
          <b-form-input
            :state="errors.has('custom-document.to') ? false : null"
            data-vv-as="destino"
            data-cy="to"
            name="to"
            v-model="formData.to"
            v-validate="'required'"
            maxLength="150"
          />
          <div
            v-if="errors.has('custom-document.to')"
            class="con-text-validation span-text-validation-danger v-enter-to"
          >
            <span class="span-text-validation">
              {{ errors.first('custom-document.to') }}
            </span>
          </div>
        </b-form-group>
      </div>
      <div class="col-md-12">
        <div class="row">
          <div class="col-md-6">
            <b-form-group label="Fecha ida *">
              <date-picker
                data-cy="departure-date"
                class="w-100"
                name="departureDate"
                format="DD-MM-YYYY"
                value-type="YYYY-MM-DD"
                data-vv-as="fecha ida"
                :danger="errors.has('custom-document.departureDate')"
                :danger-text="errors.first('custom-document.departureDate')"
                v-validate="'required'"
                v-model="formData.departureDate"
              />
              <div v-if="errors.has('custom-document.departureDate')">
                <small class="text-danger">
                  {{ errors.first('custom-document.departureDate') }}
                </small>
              </div>
            </b-form-group>
          </div>
          <div class="col-md-6">
            <b-form-group label="Hora ida *">
              <v-select
                class="w-100"
                :class="{
                  'v-select-danger': errors.has('custom-document.departureTime')
                }"
                data-cy="departure-time"
                data-vv-as="hora ida"
                name="departureTime"
                :options="optionsTime"
                v-model="formData.departureTime"
                v-validate="'required'"
              >
                <template slot="no-options">
                  no hay hora ida para el criterio de búsqueda
                </template>
              </v-select>
              <div
                v-if="errors.has('custom-document.departureTime')"
                class="con-text-validation span-text-validation-danger v-enter-to"
              >
            <span class="span-text-validation">
              {{ errors.first('custom-document.departureTime') }}
            </span>
              </div>
            </b-form-group>
          </div>
        </div>
      </div>
      <div class="col-md-12" v-if="formData.tripType === 'roundTrip'">
        <div class="row">
          <div class="col-md-6">
            <b-form-group label="Fecha regreso *">
              <date-picker
                data-cy="return-date"
                class="w-100"
                name="returnDate"
                format="DD-MM-YYYY"
                value-type="YYYY-MM-DD"
                data-vv-as="fecha regreso"
                :danger="errors.has('custom-document.returnDate')"
                :danger-text="errors.first('custom-document.returnDate')"
                v-validate="'required'"
                v-model="formData.returnDate"
              />
              <div v-if="errors.has('custom-document.returnDate')">
                <small class="text-danger">
                  {{ errors.first('custom-document.returnDate') }}
                </small>
              </div>
            </b-form-group>
          </div>
          <div class="col-md-6">
            <b-form-group label="Hora regreso *">
              <v-select
                class="w-100"
                :class="{
                  'v-select-danger': errors.has('custom-document.returnTime')
                }"
                data-cy="return-time"
                data-vv-as="hora regreso"
                name="returnTime"
                :options="optionsTime"
                v-model="formData.returnTime"
                v-validate="'required'"
              >
                <template slot="no-options">
                  no hay hora ida para el criterio de búsqueda
                </template>
              </v-select>
              <div
                v-if="errors.has('custom-document.returnTime')"
                class="con-text-validation span-text-validation-danger v-enter-to"
              >
                <span class="span-text-validation">
                  {{ errors.first('custom-document.returnTime') }}
                </span>
              </div>
            </b-form-group>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12 mt-5 mb-2">
        <h6>Documentos adjuntos</h6>
        <p>
          Toda solicitud deberá adjuntar Itinerario de desplazamiento, el programa
          de actividades a realizar durante la comisión de servicio.
          Todo documento debe ser adjuntado en formato PDF.
          Para los consejeros regionales se deberá adjuntar en Otros el Acuerdo CORE.
        </p>
      </div>
      <div class="col-md-12">
        <b-form-group label="Motivo de viaje *">
          <b-form-textarea
            :state="errors.has('custom-document.reason') ? false : null"
            data-cy="reason"
            data-vv-as="motivo de viaje"
            name="reason"
            type="text"
            rows="3"
            v-model="formData.reason"
            v-validate="'required'"
            maxLength="5000"
          />
          <div class="text-right">
            <small v-tooltip="'Contador de caracteres'">{{formData.reason.length}}/5000</small>
          </div>
          <div
            v-if="errors.has('custom-document.reason')"
            class="con-text-validation span-text-validation-danger v-enter-to"
          >
            <span class="span-text-validation">
              {{ errors.first('custom-document.reason') }}
            </span>
          </div>
        </b-form-group>
      </div>
      <div class="col-md-12">
        <div class="row">
          <label for="retinue" class="col-sm-2 col-form-label">Viaja en comitiva *</label>
          <div class="col-sm-10">
            <vs-radio
              type="radio"
              id="yes"
              vs-name="retinue"
              :vs-value="1"
              v-model="formData.retinue"
            />
            <label for="yes">Si</label><br>
            <vs-radio
              type="radio"
              id="no"
              vs-name="retinue"
              :vs-value="0"
              v-model="formData.retinue"
            />
            <label for="no">No (invitación va dirigida directamente al pasajero)</label>
          </div>
        </div>
      </div>
      <div class="col-md-12">
        <div class="row align-items-center mt-5">
          <div class="col-md-12">
            <label>Itinerario y Programa *</label>
          </div>
          <div class="col-md-3 align-items-end">
            <UploadFile
              permission="*"
              accept="application/pdf, .doc, .docx, .xlsx, .ppt"
              text="Seleccionar documentos"
              v-model="fileItinerary"
              upload-to="ed"
              :button-class="{ 'btn-block': true, 'mb-5': errors.has('custom-document.fileName') }"
              container-class="w-100"
              @input="addItineraryFile()"
            />
          </div>
          <div class="col-md-3 align-items-end">
            <b-button
              variant="secondary"
              class="btn-icon mt-1"
              @click="selectItineraryFiles('itinerary')"
              data-cy= "from-repository"
              v-has-permission="'ED060'"
              v-b-modal="'add-file-repository'"
            >
              <feather-icon icon="ServerIcon"/>
              Desde el repositorio
            </b-button>
          </div>
          <div class="col-3" v-for="file in formData.filesItinerary" :key="file.id">
            <div class="d-flex flex-column align-items-center">
              <vs-icon icon="description" size="45px" color="primary" />
              <b class="text-truncate w-100 text-center">{{ file.name }}</b>
              <vs-button
                color="danger"
                type="flat"
                icon="clear"
                @click="removeItineraryFile(file.id)"
              />
            </div>
          </div>
          <div class="col-md-12">
            <div
              v-if="!!error.messageItinerary"
              class="con-text-validation span-text-validation-danger
              vs-input--text-validation-span v-enter-to text-left"
            >
              <span class="span-text-validation">
                {{ error.messageItinerary }}
              </span>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-12">
        <div class="row align-items-center mt-5">
          <div class="col-md-12">
            <label>Otros(invitación, acuerdos core, etc) *</label>
          </div>
          <div class="col-md-3 align-items-end">
            <UploadFile
              permission="*"
              accept="application/pdf, .doc, .docx, .xlsx, .ppt"
              text="Seleccionar documentos"
              v-model="fileOthers"
              upload-to="ed"
              :button-class="{ 'btn-block': true, 'mb-5': errors.has('custom-document.fileName') }"
              container-class="w-100"
              @input="addOthersFile()"
            />
          </div>
          <div class="col-md-3 align-items-end">
            <b-button
              variant="secondary"
              class="btn-icon mt-1"
              @click="selectItineraryFiles('others')"
              data-cy= "from-repository"
              v-has-permission="'ED060'"
              v-b-modal="'add-file-repository'"
            >
              <feather-icon icon="ServerIcon"/>
              Desde el repositorio
            </b-button>
          </div>
          <div class="col-3" v-for="file in formData.filesOthers" :key="file.id">
            <div class="d-flex flex-column align-items-center">
              <vs-icon icon="description" size="45px" color="primary" />
              <b class="text-truncate w-100 text-center">{{ file.name }}</b>
              <vs-button
                color="danger"
                type="flat"
                icon="clear"
                @click="removeOthersFile(file.id)"
              />
            </div>
          </div>
          <div class="col-md-12">
            <div
              v-if="!!error.messageOthers"
              class="con-text-validation span-text-validation-danger
              vs-input--text-validation-span v-enter-to text-left"
            >
          <span class="span-text-validation">
            {{ error.messageOthers }}
          </span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row justify-end">
      <vs-button
        class="mt-5 mr-5"
        data-cy="cancel"
        @click="back()"
        color="primary"
        :disabled="saving"
      >
        Cancelar
      </vs-button>
      <vs-button

        class="mt-5 mr-5"
        data-cy="save"
        @click="save()"
        color="success"
        :disabled="saving"
      >
        Crear
        <span v-show="saving" class="spinner-border spinner-border-sm text-primary" />
      </vs-button>
    </div>
    <!--<SelectDocRepository
      :add-file="addFileRepo"
      :files="filesToAdd"
      :remove-file="removeFile"
    />-->
    <repository-selector
      modal-id="add-file-repository"
      :add-file="addFileRepo"
      :files="filesToAdd"
      :remove-file="removeFile"
    />
  </form>
</template>

<script>
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import 'vue2-datepicker/locale/es';

import { ioCreateCustomDocument, ioGetCustomDocument } from '@/febos/servicios/api/customDocuments.api';
import { ioListOptions } from '@/febos/servicios/api/herramientas.api';
import UploadFile from '@/febos/global/_vue/componentes/UploadFile';
import RutMixin from '@/febos/chile/_vue/mixins/RutMixin';
import SelectDocRepository
from '@/febos/global/customDocuments/vistas/empresas/72235100-2/components/SelectDocRepository';
import RepositorySelector from "@/febos/global/customDocuments/components/repository-selector/RepositorySelector.vue";

export default {
  name: 'SCP',
  mixins: [RutMixin],
  data() {
    return {
      isLoadOptions: false,
      optionsBudgetConcept: [],
      saving: false,
      error: {
        messageItinerary: '',
        messageOthers: ''
      },
      errorCierre: '',
      formData: {
        leadershipEmail: '',
        name: '',
        surnames: '',
        iut: '',
        birthdate: '',
        phone: '',
        tripType: 'oneWay',
        from: '',
        to: '',
        departureDate: '',
        departureTime: '',
        returnDate: '',
        returnTime: '',
        reason: '',
        retinue: 1,
        filesItinerary: [],
        filesOthers: []
      },
      fileItinerary: {},
      fileOthers: {},
      optionsTime: [
        { value: 1, label: 'MADRUGADA entre 00:00 y 6:00 AM' },
        { value: 2, label: 'MAÑANA entre las 6:01AM y las 12:00 PM' },
        { value: 3, label: 'TARDE entre las 12:01PM y las 18:00 PM' },
        { value: 5, label: 'NOCHE entre las 18:01 PM y las 23:59 PM' }
      ],
      selectFilesToAdd: ''
    };
  },
  components: {
    RepositorySelector,
    SelectDocRepository,
    UploadFile,
    DatePicker
  },
  computed: {
    filesToAdd() {
      if (this.selectFilesToAdd === 'itinerary') {
        return this.formData.filesItinerary;
      }
      return this.formData.filesOthers;
    }
  },
  methods: {
    selectItineraryFiles(type) {
      this.selectFilesToAdd = type;
    },
    removeFile(fileId) {
      if (this.selectFilesToAdd === 'itinerary') {
        this.formData.filesItinerary = this.formData.filesItinerary
          .filter((file) => file.id !== fileId);
      }
      if (this.selectFilesToAdd === 'others') {
        this.formData.filesOthers = this.formData.filesOthers
          .filter((file) => file.id !== fileId);
      }
    },
    async addFileRepo(file) {
      if (!Object.keys(file).length) {
        return;
      }

      if (file.failed) {
        this.error.message = 'La carga del archivo falló, inténtalo de nuevo';
      }

      if (this.selectFilesToAdd === 'itinerary') {
        this.formData.filesItinerary.push(file);
      }
      if (this.selectFilesToAdd === 'others') {
        this.formData.filesOthers.push(file);
      }
      this.error.message = '';
    },
    clearRut(value) {
      return typeof value === 'string' ? value.replace(/[^0-9kK]+/g, '').toUpperCase() : '';
    },
    formatIut(value, defaultParam, punto) {
      const valueClean = this.clearRut(value);
      if (!valueClean) return defaultParam;
      if (valueClean.length <= 1) return valueClean;

      let result = `${valueClean.slice(-4, -1) }-${ valueClean.substr(valueClean.length - 1)}`;
      for (let i = 4; i < valueClean.length; i += 3) result = valueClean.slice(-3 - i, -i) + (punto === 'si' ? '.' : '') + result;
      this.formData.iut = result;
      return result;
    },
    async loadOptions() {
      try {
        this.isLoadOptions = true;
        const response = await ioListOptions({
          grupoOpcion: 'io.concepto.prespuestario.gore',
          filtros: 'deshabilitado:0'
        });
        const { opciones } = response.data;
        this.optionsBudgetConcept = opciones
          .sort(({ descripcion: a }, { descripcion: b }) => a.localeCompare(b))
          .map((option) => ({
            label: `(${option.valor}) ${option.descripcion}`,
            value: option.valor
          }));
      } finally {
        this.isLoadOptions = false;
      }
    },
    async addOthersFile() {
      if (!Object.keys(this.fileOthers).length) {
        return;
      }

      if (this.fileOthers.failed) {
        this.error.messageOthers = 'La carga del archivo falló, inténtalo de nuevo';
        return;
      }

      this.formData.filesOthers.push(this.fileOthers);
      this.error.messageOthers = '';
    },
    async addItineraryFile() {
      if (!Object.keys(this.fileItinerary).length) {
        return;
      }

      if (this.fileItinerary.failed) {
        this.error.messageItinerary = 'La carga del archivo falló, inténtalo de nuevo';
        return;
      }

      this.formData.filesItinerary.push(this.fileItinerary);
      this.error.messageItinerary = '';
    },
    removeOthersFile(fileId) {
      this.formData.filesOthers = this.formData.filesOthers
        .filter((file) => file.id !== fileId);
    },
    removeItineraryFile(fileId) {
      this.formData.filesItinerary = this.formData.filesItinerary
        .filter((file) => file.id !== fileId);
    },
    async validateForm(scope) {
      const result = await this.$validator.validateAll(scope);
      return !!result;
    },
    async save() {
      const isValid = await this.validateForm('custom-document');
      if (!isValid) {
        return;
      }
      if (!this.formData.filesItinerary.length) {
        this.error.messageItinerary = 'Debe agregar el itinerario para realizar la solicitud';
        return;
      }
      if (!this.formData.filesOthers.length) {
        this.error.messageOthers = 'Debe agregar otros documentos para realizar la solicitud';
        return;
      }

      this.saving = true;
      try {
        this.$bvToast.toast(
          'Guardando documento',
          {
            title: 'En camino...',
            variant: 'primary',
            pauseOnHover: true,
            solid: true,
            autoHideDelay: 2000
          }
        );
        const payload = {
          type: this.$route.params.type,
          query: {
            numerar: 'si',
            ...this.$route.query
          },
          formData: {
            ...this.formData,
            attachments: this.formData.filesItinerary.concat(this.formData.filesOthers)
          }
        };
        const response = await ioCreateCustomDocument(payload);
        await this.generatePdf(response.data.document.id);
      } finally {
        this.saving = false;
      }
    },
    async generatePdf(id) {
      this.$bvToast.toast(
        'Generando archivo PDF',
        {
          title: 'En camino...',
          variant: 'primary',
          pauseOnHover: true,
          solid: true,
          autoHideDelay: 5000
        }
      );
      const response = await ioGetCustomDocument('SCP', id, { pdf: 'si' });
      this.$bvToast.toast(
        'Archivo generado',
        {
          title: 'Listo!',
          variant: 'primary',
          pauseOnHover: true,
          solid: true,
          autoHideDelay: 2000
        }
      );
      window.open(response.data.pdf, '_blank');
      /* eslint-disable no-restricted-globals */
      history.back();
    },
    back() {
      /* eslint-disable no-restricted-globals */
      history.back();
    }
  },
  created() {
    this.loadOptions();
  }
};
</script>
